import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { FreightsCompanyService } from "./freights-company-service";
import { FreightsCompanyRequest, FreightsCompanyResponseModel } from "@gtpl/shared-models/masters";


@ApiTags('freights-company')
@Controller('freights-company')
export class FreightsCompanyController{
    constructor(
        private service: FreightsCompanyService,
        private readonly applicationHandler: ApplicationExceptionHandler
    ){}

        @Post('/getAllActiveFreightsCompanies')
        async getAllActiveFreightsCompanies(): Promise<FreightsCompanyResponseModel>{
            try{
                return await this.service.getAllActiveFreightsCompanies()
            }catch(err){
                return this.applicationHandler.returnException(FreightsCompanyResponseModel,err)
            }
        }

        @Post('/getAllFreightsCompanies')
        async getAllFreightsCompanies(): Promise<FreightsCompanyResponseModel>{
            try{
                return await this.service.getAllFreightsCompanies()
            }catch(err){
                return this.applicationHandler.returnException(FreightsCompanyResponseModel,err)
            }
        }

        @Post('/createFreightCompany')
        @ApiBody({type:FreightsCompanyRequest})
        async createFreightCompany(@Body() req:any): Promise<FreightsCompanyResponseModel>{
            try{
                console.log(req,'...........................................')
                return await this.service.createFreightCompany(req,false)
            }catch(err){
                return this.applicationHandler.returnException(FreightsCompanyResponseModel,err)
            }
        }

        @Post('/updateFreightCompany')
        @ApiBody({type:FreightsCompanyRequest})
        async updateFreightCompany(@Body() req:any): Promise<FreightsCompanyResponseModel>{
            try{
                return await this.service.createFreightCompany(req,true)
            }catch(err){
                return this.applicationHandler.returnException(FreightsCompanyResponseModel,err)
            }
        }

        @Post('/activateDeactivateFreightCompany')
        @ApiBody({type:FreightsCompanyRequest})
        async activateDeactivateFreightCompany(@Body() req:any): Promise<FreightsCompanyResponseModel>{
            try{
                return await this.service.activateDeactivateFreightCompany(req)
            }catch(err){
                return this.applicationHandler.returnException(FreightsCompanyResponseModel,err)
            }
        }
}